<script>
import { authComputed } from '@state/helpers'
import http from "@state/http";
import MetisMenu from 'metismenujs/dist/metismenujs'
import store from "../state/store";

export default {
  components: {},
  computed: {
    ...authComputed,
    userPermission() {
      return this.$store.state.user
    },
    userRole() {
      return this.$store.state.role
    }
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active')
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add('in')
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add('active')
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add('in')
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add('active')
      }
    }


  },
  methods: {
    // Manual Download
    // openPdf () {
    //   javascipt:window.open('./../assets/files/payra_manual.docx');
    // },
    /**
     * small sidebar
     */
    smallSidebar() {
      document.body.classList.add('left-side-menu-sm')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('enlarged')
    },

    /**
     * Dark sidebar
     */
    darkSidebar() {
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.add('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Light Topbar
     */
    lightTopbar() {
      document.body.classList.add('topbar-light')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Sidebar collapsed
     */
    sidebarCollapsed() {
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.toggle('enlarged')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('topbar-light')
    },

    /**
     * Boxed Layout
     */
    boxedLayout() {
      document.body.classList.add('boxed-layout')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.add('enlarged')
      document.body.classList.remove('left-side-menu-sm')
    },
  },
  created() {
    if (store.getters['auth/loggedIn']) {
      this.$store.dispatch('getUserPermission')
    }
    if (store.getters['auth/loggedIn']) {
      this.$store.dispatch('getUserRole')
    }
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>
      <li>
        <router-link tag="a" to="/">
          <i class="fe-home"></i>
          <span>Dashboard Training</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/dashboard/resettlement">
          <i class="fe-home"></i>
          <span>Dashboard Resettlement</span>
        </router-link>
      </li>


      <li v-show="userPermission.includes('manage-ses')">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-airplay"></i>
          <span>Manage Survey </span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="userPermission.includes('ses-create')">
            <router-link tag="a" to="/ses/create" class="side-nav-link-ref">Create SES</router-link>
          </li>
          <li v-if="userPermission.includes('ses-edit')">
            <router-link tag="a" to="/ses/views/update/list" class="side-nav-link-ref">Update SES</router-link>
          </li>
          <li>
            <router-link tag="a" to="/ses/house/list" class="side-nav-link-ref">Create/Update SES House</router-link>
          </li>
          <li>
            <router-link tag="a" to="/ses/uploads/list" class="side-nav-link-ref">Upload Photo/Update SES Doc
            </router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link tag="a" to="/ses/doc/update/list" class="side-nav-link-ref">Update SES Document</router-link>-->
          <!--          </li>-->
          <!-- <li>
          <router-link tag="a" to="/ses/land/list" class="side-nav-link-ref">Land</router-link>
        </li> -->
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-eye"></i>
          <span>View SES</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/ses/land/house/report/package" class="side-nav-link-ref">Packages report
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/ses/views/list" class="side-nav-link-ref">All SES</router-link>
          </li>
          <!-- <li>
          <router-link tag="a" to="/ses/view/doc/list" class="side-nav-link-ref">All SES Document</router-link>
        </li> -->
          <li>
            <router-link tag="a" to="/ses/land/search/list" class="side-nav-link-ref">Land</router-link>
          </li>
          <li>
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
              <span>View SES Report</span>
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-second-level" aria-expanded="false">

              <li>
                <router-link tag="a" to="/ses/report" class="side-nav-link-ref">SES Report</router-link>
              </li>
              <li>
                <router-link tag="a" to="/ses/training/report" class="side-nav-link-ref">Training Info Report
                </router-link>
              </li>
              <li>
                <router-link tag="a" to="/ses/household/report" class="side-nav-link-ref">Household Report</router-link>
              </li>
              <li>
                <router-link tag="a" to="/ses/land/report" class="side-nav-link-ref">Land Report</router-link>
              </li>
              <li>
                <router-link tag="a" to="/ses/structure/report" class="side-nav-link-ref">Structure Report</router-link>
              </li>
              <li>
                <router-link tag="a" to="/ses/business/report" class="side-nav-link-ref">Business Report</router-link>
              </li>
              <!-- <li>
                            <router-link tag="a" to="/ses/centre/resettlement" class="side-nav-link-ref">Centre of Resettlement
                            </router-link>
                          </li> -->
            </ul>
          </li>
        </ul>
      </li>

      <li v-show="userPermission.includes('manage-trainee')">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-users"></i>
          <span>Manage Trainee</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="userPermission.includes('trainee-create')">
            <router-link tag="a" to="/trainee/create" class="side-nav-link-ref">Create Trainee</router-link>
          </li>
          <li v-if="userPermission.includes('trainee-edit')">
            <router-link tag="a" to="/trainee/view/update/list" class="side-nav-link-ref">Update Trainee</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/all/document/list" class="side-nav-link-ref">Upload Photo/Update Document
            </router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link tag="a" to="/trainee/view/doc/update" class="side-nav-link-ref">Update Trainee Document</router-link>-->
          <!--          </li>-->
          <li>
            <router-link tag="a" to="/trainee/followup/list" class="side-nav-link-ref">Trainee Followup</router-link>
          </li>
          <li v-if="userPermission.includes('field-book-list')">
            <router-link tag="a" to="/trainee/field-book/list" class="side-nav-link-ref">Field Book</router-link>
          </li>
          <!-- <li>
          <a href="javascript: void(0);" aria-expanded="false">
                Field Book Group
            <span class="menu-arrow"></span>
          </a>
          <ul class="nav-third-level nav" aria-expanded="false">
            <li>
              <router-link tag="a" to="/trainee/field-book/group/list" class="side-nav-link-ref">Field Book Group
              </router-link>
            </li>
            <li>
              <router-link tag="a" to="/trainee/field-book/group/view" class="side-nav-link-ref">View Group
              </router-link>
                        </li>
            <li>
              <router-link tag="a" to="/trainee/field-book/group/update/list" class="side-nav-link-ref">Update Group
              </router-link>
            </li>
          </ul>
        </li> -->
          <li>
            <router-link tag="a" to="/trainee/bank/update/list" class="side-nav-link-ref">Add/Update Bank To Trainee
            </router-link>
          </li>
          <!-- <li>
            <router-link tag="a" to="/trainee/bank/import" class="side-nav-link-ref">Bank Import</router-link>
          </li> -->
          <!-- <li>
            <a href="javascript: void(0);" aria-expanded="false">
              Voucher
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li v-if="userPermission.includes('voucher-create')">
                <router-link tag="a" to="/trainee/voucher/create" class="side-nav-link-ref">Create Voucher</router-link>
              </li>
              <li v-if="userPermission.includes('voucher-update')">
                <router-link tag="a" to="/trainee/voucher/update/list" class="side-nav-link-ref">Update Voucher</router-link>
              </li>
            </ul>
          </li> -->
          <!-- <li>
                                  <a href="javascript: void(0);" aria-expanded="false">
                                    Manage Trade Course
                                    <span class="menu-arrow"></span>
                                  </a>
                                  <ul class="nav-third-level nav" aria-expanded="false">
                                    <li v-if="userPermission.includes('trade-course-create')" >
                                      <router-link tag="a" to="/trainee/trade/course/create" class="side-nav-link-ref">Create Trade Course</router-link>
                                    </li>
                                    <li v-if="userPermission.includes('trade-course-update')">
                                      <router-link tag="a" to="/trainee/trade/course/updateList" class="side-nav-link-ref">Update Trade Course</router-link>
                                    </li>
                                  </ul>
                                </li> -->
          <li>
            <router-link tag="a" to="/trainee/profile/search" class="side-nav-link-ref">Trainee Search</router-link>
          </li>
          <!-- <li>
            <a href="javascript: void(0);" aria-expanded="false">
              Manage Exam
                                    <span class="menu-arrow"></span>
                                  </a>
                                  <ul class="nav-third-level nav" aria-expanded="false">
                                    <li>
                                      <router-link tag="a" to="/trainee/exam/create" class="side-nav-link-ref">Create Exam</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/trainee/exam/list" class="side-nav-link-ref">Update Exam</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/trainee/grade" class="side-nav-link-ref">Grade</router-link>
                                    </li>
                                  </ul>
                                </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/trainee/list/pdf" class="side-nav-link-ref">Print Trainee</router-link>
                                </li> -->
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-eye"></i>
          <span>View Trainee</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/trainee/batch/list" class="side-nav-link-ref">All Trainee</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/list" class="side-nav-link-ref">All Trainee/TNA</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/waiting/list" class="side-nav-link-ref">All Waiting Trainee</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/view/doc/list" class="side-nav-link-ref">All Trainee Document
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/bank/list" class="side-nav-link-ref">All Bank Trainee</router-link>
          </li>
          <!-- <li>
                                  <router-link tag="a" to="/trainee/followup/search/list" class="side-nav-link-ref">Trainee Followup</router-link>
                                </li> -->
          <li>
            <router-link tag="a" to="/trainee/followup/report/list" class="side-nav-link-ref">Trainee Followup List
            </router-link>
          </li>
          <!-- <li>
                                  <router-link tag="a" to="/trainee/field-book/view/list" class="side-nav-link-ref">Field Book</router-link>
                                </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/trainee/batch/field-book/list" class="side-nav-link-ref">Batch Trainee Field Book</router-link>
                                </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/trainee/not/field-book/list" class="side-nav-link-ref">Trainee Waiting Field Book</router-link>
                                </li> -->
          <li>
            <router-link tag="a" to="/trainees/nid-duplicate/list" class="side-nav-link-ref">Trainee Check</router-link>
          </li>
          <!-- <li>
                    <router-link tag="a" to="/trainees/field-book/list" class="side-nav-link-ref">Field Book Trainee
                    </router-link>
                  </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/trainees/field-book/mismatch/list" class="side-nav-link-ref">Field Book Mismatch</router-link>
                                </li> -->
          <!-- <li>
                                  <a href="javascript: void(0);" aria-expanded="false">
                                    Manage Voucher
                                    <span class="menu-arrow"></span>
                                  </a>
                                  <ul class="nav-third-level nav" aria-expanded="false">
                                    <li>
                                      <router-link tag="a" to="/trainee/voucher/list" class="side-nav-link-ref">All Voucher</router-link>
                                    </li>
                                  </ul>
                                </li> -->
          <!-- <li>
                                  <a href="javascript: void(0);" aria-expanded="false">
              View Trade Course
              <span class="menu-arrow"></span>
                                  </a>
                                  <ul class="nav-third-level nav" aria-expanded="false">
                                    <li>
                                      <router-link tag="a" to="/trainee/trade/course/list" class="side-nav-link-ref">All Trade Course</router-link>
                                    </li>
                                  </ul>
                                </li> -->
          <!-- <li>
                                  <a href="javascript: void(0);" aria-expanded="false">
                                    View Exam
                                    <span class="menu-arrow"></span>
                                  </a>
                                  <ul class="nav-third-level nav" aria-expanded="false">
                                    <li>
                                      <router-link tag="a" to="/trainee/exam/list/view" class="side-nav-link-ref">All Exam</router-link>
                                    </li>
                                    <li>
                                      <router-link tag="a" to="/batch/grade/list" class="side-nav-link-ref">Grade</router-link>
              </li>
              <li>
                                      <router-link tag="a" to="/trainee/grade/view" class="side-nav-link-ref">All Trainee Grade</router-link>
                                    </li>
                                  </ul>
                                </li> -->
          <li>
            <a href="javascript: void(0);" aria-expanded="false">
              ID Card
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link tag="a" to="/trainee/id-card" class="side-nav-link-ref">Trainee</router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainer/id-card" class="side-nav-link-ref">Trainer</router-link>
              </li>
            </ul>
          </li>
          <!--          <li>-->
          <!--            <router-link tag="a" to="/trainers/list" class="side-nav-link-ref">All Trainers</router-link>-->
          <!--          </li>-->
          <!-- <li>
                                  <router-link tag="a" to="/batch/trainee" class="side-nav-link-ref">Search Trainee</router-link>
                                </li> -->
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-file"></i>
          <span>View Trainee Report</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">

          <!-- iga information -->
          <li>
            <a href="javascript: void(0);" aria-expanded="false">
              IGA Information
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link tag="a" to="/trainee/iga/self-emplyment/list" class="side-nav-link-ref">Self Employment
                </router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/iga/income-from-trade/list" class="side-nav-link-ref">Income From
                  Trade</router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/iga/job-holder/list" class="side-nav-link-ref">Involved With Job
                </router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/iga/involved-with-others/list" class="side-nav-link-ref">Involved With
                  Others</router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/iga/employment-status" class="side-nav-link-ref">Employment Status
                </router-link>
              </li>
            </ul>
          </li>

          <li>
            <router-link tag="a" to="/trainee/education/report" class="side-nav-link-ref">Education Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/report/document/list" class="side-nav-link-ref">Trainee/TNA Doc
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/batch/report" class="side-nav-link-ref">Batch Report</router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link tag="a" to="/trainee/batch/report" class="side-nav-link-ref">Trainee Batch Report</router-link>-->
          <!--          </li>-->
          <!--          <li>-->
          <!--            <router-link tag="a" to="/trainee/report" class="side-nav-link-ref">Trainee Report</router-link>-->
          <!--          </li>-->
          <li>
            <router-link tag="a" to="/trainee/bank/report" class="side-nav-link-ref">Trainee Bank Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/batch/attendance/report" class="side-nav-link-ref">Attendance report
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/trade/report" class="side-nav-link-ref">Trade report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/mouza/report" class="side-nav-link-ref">Mouza report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/union/report" class="side-nav-link-ref">Union report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/all/trade/report" class="side-nav-link-ref">Trainee & Trade Report
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/all/batch/report" class="side-nav-link-ref">Trainee & Batch Report
            </router-link>
          </li>
          <!-- <li>
                                      <router-link tag="a" to="/activity/report" class="side-nav-link-ref">Activity Report</router-link>
                                  </li> -->
          <li>
            <router-link tag="a" to="/trainee/age/report" class="side-nav-link-ref">Trainee Age Report</router-link>
          </li>

          <li>
            <router-link tag="a" to="/trade/trainee/age/report" class="side-nav-link-ref">Trade Age report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/mouza/trainee/age/report" class="side-nav-link-ref">Mouza Age Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/mouza/trainee/followup/age/report" class="side-nav-link-ref">Mouza Followup Age
              Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/union/trainee/age/report" class="side-nav-link-ref">Union Age report</router-link>
          </li>
          <!-- <li>
                                  <router-link tag="a" to="/trainee/voucher/date/list" class="side-nav-link-ref">Trainee Voucher</router-link>
                                </li> -->
          <li>
            <router-link tag="a" to="/trainee/voucher/report" class="side-nav-link-ref">Honorarium report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainee/followup/report" class="side-nav-link-ref">Followup report</router-link>
          </li>
          <!-- <li>
                                  <router-link tag="a" to="/calculation-sheet" class="side-nav-link-ref">Calculation Sheet</router-link>
                                </li> -->
          <li>
            <router-link tag="a" to="/trainee/age-group/report" class="side-nav-link-ref">Age Group Report</router-link>
          </li>
          <!-- <li>
                  <router-link tag="a" to="/trainee/field-book/report" class="side-nav-link-ref">Field Book Report
                  </router-link>
                </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/testingReport" class="side-nav-link-ref">Testing Report</router-link>
                                </li> -->
          <!-- <li>
                                  <router-link tag="a" to="/trainee/after-training-iga-info" class="side-nav-link-ref">After Training Iga Info</router-link>
                                </li> -->
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-github"></i>
          <span>Manage Batch</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="userPermission.includes('batch-create')">
            <router-link tag="a" to="/batch/create" class="side-nav-link-ref">Create Batch</router-link>
          </li>
          <li v-if="userPermission.includes('batch-edit')">
            <router-link tag="a" to="/batch/update/list" class="side-nav-link-ref">Update Batch</router-link>
          </li>
          <li v-if="userPermission.includes('batch-edit')">
            <router-link tag="a" to="/batch/update/modify/list" class="side-nav-link-ref">Modify Batch</router-link>
          </li>
          <li v-if="userPermission.includes('trainee-to-batch-create')">
            <router-link tag="a" to="/batch/trainee/add" class="side-nav-link-ref">Add Trainee To Batch</router-link>
          </li>
          <li v-if="userPermission.includes('trainee-to-batch-update')">
            <router-link tag="a" to="/batch/trainee/list" class="side-nav-link-ref">Update Trainee To Batch
            </router-link>
          </li>
          <li>
            <a href="javascript: void(0);" aria-expanded="false">
              Manage Attendance
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li v-if="userPermission.includes('attendance-create') || userPermission.includes('attendance-edit')">
                <router-link tag="a" to="/trainee/attendance/add" class="side-nav-link-ref">Add Attendance</router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/attendance/delete" class="side-nav-link-ref">Delete Attendance
                </router-link>
              </li>
            </ul>
          </li>
          <!-- <li>
                                  <router-link tag="a" to="/batch/all/document/list" class="side-nav-link-ref">Create/Update Batch Document</router-link>
                                </li> -->
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-eye"></i>
          <span>View Batch</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/batch/list" class="side-nav-link-ref">All Batch</router-link>
          </li>
          <li>
            <router-link tag="a" to="/batch/completed/list" class="side-nav-link-ref">Completed Batch</router-link>
          </li>
          <li>
            <router-link tag="a" to="/batch/ongoing/list" class="side-nav-link-ref">Ongoing Batch</router-link>
          </li>
          <li>
            <router-link tag="a" to="/batch/upcoming/list" class="side-nav-link-ref">Upcoming Batch</router-link>
          </li>
          <li>
            <router-link tag="a" to="/batch/trainee/view" class="side-nav-link-ref">All Batch Trainee</router-link>
          </li>
          <li>
            <a href="javascript: void(0);" aria-expanded="false">
              View Attendance
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link tag="a" to="/trainee/batch/attendance/list" class="side-nav-link-ref">Batch Attendance
                </router-link>
              </li>
              <li>
                <router-link tag="a" to="/trainee/batch/daily-attendance/report" class="side-nav-link-ref">Daily
                  Attendance Report</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li v-show="userRole.includes('Admin') || userRole.includes('Super Admin')">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-user"></i>
          <span>User & Log Reports</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/user/list" class="side-nav-link-ref">All User</router-link>
          </li>
          <li>
            <router-link tag="a" to="/user/role/list" class="side-nav-link-ref">Roles</router-link>
          </li>
          <li>
            <router-link tag="a" to="/user/active-users" class="side-nav-link-ref">Active Users</router-link>
          </li>
          <li>
            <router-link tag="a" to="/user/logged/list" class="side-nav-link-ref">User Logged in Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/user/role/logged/list" class="side-nav-link-ref">User Role Logged Report
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/role/logged/list" class="side-nav-link-ref">Role Logged Report</router-link>
          </li>
          <li>
            <router-link tag="a" to="/activity-log" class="side-nav-link-ref">System Activity Log</router-link>
          </li>
        </ul>
      </li>

      <li v-show="userPermission.includes('crud-module')">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-settings"></i>
          <span>Master Data</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/users/list" class="side-nav-link-ref">Users</router-link>
          </li>
          <li>
            <router-link tag="a" to="/affected-type/list" class="side-nav-link-ref">Affected Type</router-link>
          </li>
          <li>
            <router-link tag="a" to="/mouzas/list" class="side-nav-link-ref">Mouzas</router-link>
          </li>
          <li>
            <router-link tag="a" to="/villages/list" class="side-nav-link-ref">Villages</router-link>
          </li>
          <li>
            <router-link tag="a" to="/banks/list" class="side-nav-link-ref">Banks</router-link>
          </li>

          <li>
            <router-link tag="a" to="/upazilas/list" class="side-nav-link-ref">Upazilas</router-link>
          </li>
          <li>
            <router-link tag="a" to="/venues/list" class="side-nav-link-ref">Training Venues</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trainers-module/list" class="side-nav-link-ref">Trainers</router-link>
          </li>
          <li>
            <router-link tag="a" to="/trades/list" class="side-nav-link-ref">Trades</router-link>
          </li>
          <li>
            <router-link tag="a" to="/training-duration/list" class="side-nav-link-ref">Training Duration</router-link>
          </li>
        </ul>
      </li>

      <li class="has-submenu">
        <router-link tag="a" to="/trainee/search/custom">
          <i class="fe-search"></i>
          <span>Custom Search</span>
        </router-link>
      </li>
      <li>
        <a href="/assets/files/payra_manual.docx" download>Download user Manual</a>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>